import React from 'react';

export default function KPICard({ label, value, sub, color = 'var(--blue)', icon, delta }) {
  return (
    <div className="kpi-card" style={{ '--kpi-accent': color }}>
      <div className="kpi-top-bar" />
      {icon && <div className="kpi-icon">{icon}</div>}
      <div className="kpi-value">{value}</div>
      <div className="kpi-label">{label}</div>
      {sub && <div className="kpi-sub">{sub}</div>}
      {delta && (
        <div className={`kpi-delta ${delta.direction === 'up' ? 'up' : 'down'}`}>
          {delta.direction === 'up' ? '↑' : '↓'} {delta.text}
        </div>
      )}
    </div>
  );
}

export function KPIGrid({ children }) {
  return <div className="kpi-grid">{children}</div>;
}
